import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	deaOtherAddressColumn,
	licenseColumn,
	openLicenseActionColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * DEA Registered at a Different Address (PD-17113) — active buyers with a
 * CONFIRMED DEA match whose registration is not at any of the account's
 * locations. A DEA registration covers one principal place of business (21 CFR
 * 1301.12(a)), so a DEA registered elsewhere may not cover where the account
 * ships. The match stays confirmed — this is a compliance review, not a
 * checkout block (Chris, 2026-10-17) — and the row shows the registered
 * address against the ship-to.
 *
 * Two readings share the list (Chris, 2026-10-18): a truly different location
 * ("Different address"), and one the address comparison cannot tell — a
 * neighboring house number, a PO box, a street written another way — worded
 * "May differ — check".
 *
 * The comparison runs in TypeScript (crm-api dea-location-separation.ts), so
 * the licenses service resolves `licenseDeaOtherAddress: yes` to license ids —
 * the same set the dashboard card counts and the client record calls out.
 */
export const deaOtherAddressList: ListBuilderList = {
	id: 'compliance-dea-other-address',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'DEA Address',
	type: 'default',
	active: true,
	sortOrder: 7,
	filterRules: {
		...hideOtherCardFilters(['licenseDeaOtherAddress']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseDeaOtherAddress: {
			defaultValue: [
				{ id: 'yes', label: 'DEA registered at a different address' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		deaOtherAddressColumn,
		whyHereColumn,
		openLicenseActionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
